// removed by extract-text-webpack-plugin
module.exports = {"header":"src-components-Header----style-module---header---EICu5","logo":"src-components-Header----style-module---logo---354Jd","logoImg":"src-components-Header----style-module---logoImg---34JwX","nav":"src-components-Header----style-module---nav---2ws84","navLinkMore":"src-components-Header----style-module---navLinkMore---2hJyg","moreContent":"src-components-Header----style-module---moreContent---uZmdt","navItem":"src-components-Header----style-module---navItem---2O7di","appear":"src-components-Header----style-module---appear---xY9kb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/style.module.css
// module id = 351
// module chunks = 114276838955818